import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { HotelSample } from '../../../assests/ExportImageIcon'
import service from '../../../services/service'
import endpoints from '../../../services/endpoints'
import '../mytrip/mytrips.css'
import './myRfps.css'

const STATUS_LABELS = {
    rfp_received: 'RFP Received',
    quotation_sent: 'Quotation Sent',
    accepted: 'Accepted',
    rejected: 'Rejected',
}

const formatDate = (dateStr) => {
    if (!dateStr) return '—'
    // API sometimes returns "YYYY-MM-DD HH:mm:ss" (space-separated, no
    // timezone) instead of strict ISO — normalize to "T" so this parses
    // reliably across browsers (Safari doesn't accept the space variant).
    const normalized = typeof dateStr === 'string' ? dateStr.replace(' ', 'T') : dateStr
    const date = new Date(normalized)
    if (Number.isNaN(date.getTime())) return dateStr
    return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
}

const mapRfp = (rfp) => ({
    id: rfp.id,
    image: rfp.venue_cover_photo || HotelSample,
    venueName: rfp.venue_name || 'Venue',
    eventType: rfp.event_type_name || '—',
    date: formatDate(rfp.start_time),
    guests: rfp.expected_guest_count ?? '—',
    statusLabel: STATUS_LABELS[rfp.status] || rfp.status || '—',
})

const ArrowRight = () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path d="M3 9h11M10 5l4 4-4 4" stroke="#026D4D" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || ''

const MyRfps = () => {
    const navigate = useNavigate()
    const [rfps, setRfps] = useState([])
    const [loading, setLoading] = useState(true)
    const [nextPageUrl, setNextPageUrl] = useState(null)
    const [loadingMore, setLoadingMore] = useState(false)

    useEffect(() => {
        setLoading(true)
        service
            .get(endpoints.venues.rfps, {}, { silent: true })
            .then(({ data }) => {
                const list = Array.isArray(data?.data) ? data.data : []
                setRfps(list.map(mapRfp).sort((a, b) => b.id - a.id))
                setNextPageUrl(data?.next || null)
            })
            .catch(() => setRfps([]))
            .finally(() => setLoading(false))
    }, [])

    const loadMore = () => {
        if (!nextPageUrl || loadingMore) return
        setLoadingMore(true)
        const relativeUrl = nextPageUrl.replace(API_BASE_URL, '')
        service
            .get(relativeUrl, {}, { silent: true })
            .then(({ data }) => {
                const list = Array.isArray(data?.data) ? data.data : []
                setRfps((prev) => [...prev, ...list.map(mapRfp)])
                setNextPageUrl(data?.next || null)
            })
            .catch(() => {})
            .finally(() => setLoadingMore(false))
    }

    return (
        <div className='myTrips'>
            <div className='myRfps__header'>
                <div className='bsSectionTitle' style={{ marginBottom: 0 }}>My RFPs</div>
                <button type='button' className='myRfps__userRfpBtn' onClick={() => navigate('/venue-booking-confirm')}>
                    User RFP
                </button>
            </div>

            {loading && <p className='fare-extra-hint'>Loading your RFPs...</p>}
            {!loading && !rfps.length && (
                <p className='fare-extra-hint'>You haven&apos;t sent any venue requests yet.</p>
            )}

            {!loading && rfps.length > 0 && (
                <div className='myTripsList'>
                    {rfps.map((rfp) => (
                        <div
                            className='myTripCard'
                            key={rfp.id}
                            role='button'
                            tabIndex={0}
                            onClick={() => navigate(`/venue-proposal-detail/${rfp.id}`)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault()
                                    navigate(`/venue-proposal-detail/${rfp.id}`)
                                }
                            }}
                        >
                            <div className='myTripCard__top'>
                                <span className='myTripCard__id'>RFP ID: {rfp.id}</span>
                                <span className='myTripCard__status'>{rfp.statusLabel}</span>
                            </div>
                            <div className='rfpCard__main'>
                                <div className='myTripCard__service'>
                                    <span className='myTripCard__icon'>
                                        <img src={rfp.image} alt='' />
                                    </span>
                                    <div className='myTripCard__info'>
                                        <div className='myTripCard__title'>{rfp.venueName}</div>
                                        <div className='myTripCard__code'>{rfp.eventType}</div>
                                    </div>
                                </div>
                                <div className='rfpCard__meta'>
                                    <div className='rfpCard__metaItem'>
                                        <span className='rfpCard__metaLabel'>Date:</span>
                                        <span className='rfpCard__metaValue'>{rfp.date}</span>
                                    </div>
                                    <div className='rfpCard__metaItem'>
                                        <span className='rfpCard__metaLabel'>Guests:</span>
                                        <span className='rfpCard__metaValue'>{rfp.guests}</span>
                                    </div>
                                </div>
                                <span className='myTripCard__arrow' aria-hidden='true'>
                                    <ArrowRight />
                                </span>
                            </div>
                            <button
                                type='button'
                                className='travellerAddBtn w-100 mt-3'
                                onClick={(e) => {
                                    e.stopPropagation()
                                    navigate(`/venue-suggested-venues/${rfp.id}`)
                                }}
                            >
                                Send to More Venues
                            </button>
                        </div>
                    ))}
                </div>
            )}

            {nextPageUrl ? (
                <button type='button' className='travellerAddBtn w-100 mt-3' disabled={loadingMore} onClick={loadMore}>
                    {loadingMore ? 'Loading...' : 'Load More RFPs'}
                </button>
            ) : null}
        </div>
    )
}

export default MyRfps
